import { CircularProgress, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import GetAppIcon from '@material-ui/icons/GetApp';

import * as socketEvents from 'constants/socketEvents';
import socket from 'services/socket';

type ButtonDownloadMidiaProps = {
  mensagemId?: string;
  grupoChatId?: string;
  atendimentoId?: string;
  buttonText?: string;
  baixando?: boolean;
};

const useStyles = makeStyles(({ palette }) => ({
  root: {
    color: 'inherit',
    backgroundColor: palette.action.selected,
  },
}));

export default function ButtonDownloadMidia(props: ButtonDownloadMidiaProps) {
  const {
    mensagemId,
    grupoChatId,
    atendimentoId,
    buttonText = 'Recarregar mensagem',
    baixando,
  } = props;

  const classes = useStyles();

  const handleClick = () => {
    if (grupoChatId) {
      const data = { id: mensagemId, grupoChatId };
      socket.emit(socketEvents.EMIT_DOWNLOAD_MIDIA_GRUPO, data);
    } else if (atendimentoId) {
      const data = { id: mensagemId, atendimentoId };
      socket.emit(socketEvents.EMIT_DOWNLOAD_MIDIA, data);
    }
  };

  return (
    <IconButton
      className={classes.root}
      onClick={handleClick}
      disabled={baixando}
      title={buttonText}
      color="inherit"
    >
      {baixando ? (
        <CircularProgress color="inherit" size={24} />
      ) : (
        <GetAppIcon />
      )}
    </IconButton>
  );
}
